import React, { useState } from 'react';
import PropTypes from 'prop-types';
import RadarChartComponent from './RadarChartComponent';
import HardSkillsList from './HardSkillsList';
import CustomTooltip from '../../Utils/CustomTooltip';

const HardSkillsSection = ({ hardSkills, radarChartMode = 'required', showSources = true }) => {
  // radarChartMode can be 'all', 'required', or 'none'
  // BACKWARDS COMPATIBILITY -> Helper function to get items array, checking both 'items' and 'value' properties
  const getItemsArray = (data) => {
    if (Array.isArray(data?.items) && data.items.length > 0) {
      return data.items;
    } else if (Array.isArray(data?.value) && data.value.length > 0) {
      return data.value;
    }
    return [];
  };
  
  // Get the skills array and sort it so that top5 skills are at the top
  const skillsArray = getItemsArray(hardSkills).sort((a, b) => {
    const aIsTop = Boolean(a.top5);
    const bIsTop = Boolean(b.top5);
    
    if (aIsTop && !bIsTop) return -1;
    if (!aIsTop && bIsTop) return 1;
    return 0;
  });
  return (
    <div className="border border-gray-200 rounded-lg p-6 bg-white">
      <div className="flex justify-between items-start mb-4">
        <h4 className="text-xl font-semibold text-gray-800">Hard Skills</h4>
        {showSources && hardSkills?.source && (
          <CustomTooltip content={hardSkills.source} position="left">
            <span className="text-xs text-blue-600 cursor-help hover:text-blue-800 flex items-center">
              <svg className="w-3 h-3 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
              </svg>
              Source
            </span>
          </CustomTooltip>
        )}
      </div>
      
      {skillsArray.length > 0 ? (
        <div>
          {/* Radar Chart on top */}
          {radarChartMode !== 'none' && (
            <div className="mb-8">
              <RadarChartComponent 
                data={skillsArray
                  .filter(skill => radarChartMode === 'all' ? true : skill.importance === "Required")
                  .map(skill => ({
                    subject: skill.skill,
                    value: skill.grade
                  }))}
                title={radarChartMode === 'all' ? "All Skills Radar" : "Required Skills Radar"}
                height="h-[500px]"
                marginTop="mt-0"
                marginBottom="mb-6"
              />
            </div>
          )}
          
          {/* Hard Skills List Component */}
          <HardSkillsList skills={skillsArray} showSources={showSources} />
        </div>
      ) : (
        <p className="text-gray-600">No hard skills data available.</p>
      )}
    </div>
  );
};

HardSkillsSection.propTypes = {
  hardSkills: PropTypes.object,
  radarChartMode: PropTypes.string,
  showSources: PropTypes.bool
};

export default HardSkillsSection;
